import { Component, forwardRef, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type Direction = 'horizontal' | 'vertical' | 'horizontal-reverse';

const CheckboxDirectionStyles = {
  horizontal: 'flex flex-row space-x-2 items-center',
  vertical: 'flex flex-col space-y-2 items-start',
  'horizontal-reverse': 'flex flex-row-reverse space-x-2 items-center',
};

@Component({
  selector: 'app-checkbox',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent implements ControlValueAccessor {
  label = input<string>('');
  id = input<string>('');
  direction = input<Direction>('horizontal');

  protected checkboxDirectionStyles = CheckboxDirectionStyles;

  value = false;
  isDisabled = false;

  private onChange: (value: boolean) => void = () => {
    //
  };
  private onTouched: () => void = () => {
    //
  };

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onValueChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.checked;
    this.onChange(this.value);
    this.onTouched();
  }
}
